import React from 'react'
import ReportStyle from '../style/CreditReportSkeleton.module.css'
const CreditReportSkeleton = (props) => {
    const {totalRow} = props;
    return (
        <>
           {[...Array(totalRow)].map((_, index) => (
                <div className={`${ReportStyle.skeletonRow}`} key={index}>
                    <div className={`${ReportStyle.skeletonDate} ${ReportStyle.shimmer}`}></div>
                    <div className={`${ReportStyle.skeletonStatus} ${ReportStyle.shimmer}`}></div>
                    <div className={`${ReportStyle.skeletonAmount} ${ReportStyle.shimmer}`}></div>
                </div>
            ))}
        </>
    )
}

export default CreditReportSkeleton